import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AgenteControlService } from './agentecontrol.service';
import { RegAgenteControlComunidadAutonomaViewModel, RegAgenteControlCaFormaViewModel } from './agentecontrol.types';
import { FormaViewModel } from '../../especies/gruposformas/grupoforma.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'app-agentecontrolca-edit',
    templateUrl: './agentecontrolca-edit.component.html',
})
export class AgenteControlCaEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nueva';
    listComunidad: Tc[];
    agenteControlCa: RegAgenteControlComunidadAutonomaViewModel;
    visibilitySpinner = false;
    isCollapsedEntidad = false;
    habilitarGuardar = false;
    listGrupos: Tc[];
    listFormas: FormaViewModel[];
    numFormas = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private agenteControlService: AgenteControlService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.agenteControlCa = new RegAgenteControlComunidadAutonomaViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['idAgenteControlCa'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.agenteControlService.getAgenteControlComunidadAutonoma(id).subscribe(result => {
                this.agenteControlCa = result;
                this.updateForm();
                this.numFormas = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.length;
            });

            this.form.controls['IdCa'].disable();
        } else {
            this.editMode = false;
            this.form.controls['IdCa'].enable();
        }

        this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_AGENTE_CONTROL).Visible;

        if (!this.habilitarGuardar) {
            this.DisableControls();
        }

        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidad = res;
        });

        this.globalService.getGrupos().subscribe(result => {
            this.listGrupos = result;
        });
        this.globalService.getFormas().subscribe(result => {
            this.listFormas = result;
        });
    }

    DisableControls() {
        this.form.controls['IdForma'].disable();
        this.form.controls['IdGrupo'].disable();
        //this.form.controls['btnDeleteForma'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            IdCa: [null, Validators.required],
            ActivacionInicial: true,
            FechaActivacionInicial: null,
            Baja: false,
            FechaBaja: null,
            IdGrupo: null,
            IdForma: null,
        });
    }

    updateForm() {
        this.form.setValue({
            IdCa: this.agenteControlCa.IdCa,
            ActivacionInicial: this.agenteControlCa.ActivacionInicial,
            FechaActivacionInicial: this.agenteControlCa.FechaActivacionInicial != null ? new Date(this.agenteControlCa.FechaActivacionInicial) : null,
            Baja: this.agenteControlCa.Baja,
            FechaBaja: this.agenteControlCa.FechaBaja != null ? new Date(this.agenteControlCa.FechaBaja) : null,
            IdGrupo: null,
            IdForma: null,
        });
    }

    onAddForma() {
        if (this.form.value.IdForma != null && this.form.value.IdForma > 0) {
            //this.removeValidators("IdForma");
            //this.addValidator("IdForma", Validators.required);

            //if (this.isFieldInvalidNoSubmit("IdForma", "required")) {

            //    return;
            //}

            //this.removeValidators("IdForma");

            let currentAcCaForma = new RegAgenteControlCaFormaViewModel();
            currentAcCaForma.IdForma = this.form.value.IdForma;
            currentAcCaForma.IdAcCa = this.agenteControlCa.Id;

            if (this.agenteControlCa.TwRegAgenteControlCaFormaCollection == null) {
                this.agenteControlCa.TwRegAgenteControlCaFormaCollection = new Array<RegAgenteControlCaFormaViewModel>();
            }

            //Comprobamos que no esté ya incluido
            let yaIncluido = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.find(it => it.IdForma == currentAcCaForma.IdForma);

            if (yaIncluido) {
                return;
            }

            //Si no está incluido todavía, actualizamos el listbox
            let formaSeleccionada = this.listFormas.find(it => it.Id == this.form.value.IdForma);

            if (formaSeleccionada != null) {
                currentAcCaForma.IdFormaDescripcion = formaSeleccionada.Descripcion;
            }

            this.agenteControlCa.TwRegAgenteControlCaFormaCollection.push(currentAcCaForma);
            this.numFormas = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.length;

            this.form.patchValue({
                IdPuntoInspeccion: null,
            });
        }
    }

    onAddFormaPorGrupo() {
        if (this.form.value.IdGrupo != null && this.form.value.IdGrupo > 0) {
            let formasGrupo = this.listFormas.filter(it => it.IdGrupo == this.form.value.IdGrupo);

            if (formasGrupo != null) {
                for (let i = 0, len = formasGrupo.length; i < len; i++) {
                    let currentAcCaForma = new RegAgenteControlCaFormaViewModel();
                    currentAcCaForma.IdForma = formasGrupo[i].Id;
                    currentAcCaForma.IdAcCa = this.agenteControlCa.Id;

                    if (this.agenteControlCa.TwRegAgenteControlCaFormaCollection == null) {
                        this.agenteControlCa.TwRegAgenteControlCaFormaCollection = new Array<RegAgenteControlCaFormaViewModel>();
                    }

                    //Comprobamos que no esté ya incluido
                    let yaIncluido = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.find(it => it.IdForma == currentAcCaForma.IdForma);

                    if (!yaIncluido) {
                        //Si no está incluido todavía, actualizamos el listbox

                        currentAcCaForma.IdFormaDescripcion = formasGrupo[i].Descripcion;

                        this.agenteControlCa.TwRegAgenteControlCaFormaCollection.push(currentAcCaForma);
                        this.numFormas = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.length;

                        //this.removeValidators("IdForma");

                        this.form.patchValue({
                            IdForma: null,
                        });
                    }
                }
            }

            //this.addValidator("IdPuntoInspeccion", Validators.required);
        }
    }

    onDeleteForma(item: RegAgenteControlCaFormaViewModel) {
        this.agenteControlCa.TwRegAgenteControlCaFormaCollection.splice(this.agenteControlCa.TwRegAgenteControlCaFormaCollection.indexOf(item), 1);
        this.numFormas = this.agenteControlCa.TwRegAgenteControlCaFormaCollection.length;
    }

    sortByForma(prop: string) {
        if (this.editMode && this.agenteControlCa.TwRegAgenteControlCaFormaCollection != null) {
            return this.agenteControlCa.TwRegAgenteControlCaFormaCollection.sort(function (a, b) {
                return a.IdFormaDescripcion.localeCompare(b.IdFormaDescripcion);
            });
        } else {
            return this.agenteControlCa.TwRegAgenteControlCaFormaCollection;
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedEntidad = false;
            return;
        }

        this.visibilitySpinner = true;

        let agenteControlCa = new RegAgenteControlComunidadAutonomaViewModel();

        agenteControlCa.IdCa = this.form.value.IdCa != null ? this.form.value.IdCa : this.agenteControlCa.IdCa;
        agenteControlCa.ActivacionInicial = this.form.value.ActivacionInicial;
        agenteControlCa.FechaActivacionInicial = this.form.value.FechaActivacionInicial;
        agenteControlCa.Baja = this.form.value.Baja;
        agenteControlCa.FechaBaja = this.form.value.FechaBaja;

        agenteControlCa.Id = this.agenteControlCa.Id;
        agenteControlCa.IdAgenteControl = this.activatedRoute.snapshot.params['id'];

        //Colecciones
        agenteControlCa.TwRegAgenteControlCaFormaCollection = this.agenteControlCa.TwRegAgenteControlCaFormaCollection;

        if (this.editMode) {
            this.agenteControlService.editAgenteControlComunidadAutonoma(agenteControlCa).subscribe({
                next: () => {
                    this.addSuccessMessage('CA modificada correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        } else {
            this.agenteControlService.addAgenteControlComunidadAutonoma(agenteControlCa).subscribe({
                next: () => {
                    this.addSuccessMessage('CA añadida correctamente');
                    this.visibilitySpinner = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack() {
        let idAgenteControl = this.activatedRoute.snapshot.params['id'];
        this.router.navigate(['/mantenimiento/registros/agentescontrol/edit', idAgenteControl]);
    }
}
